import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorksSection = () => {
  const steps = [
    {
      number: "01",
      iconName: "PenLine",
      title: "Share Your Story",
      description: "Write about your emotional struggles, challenges, or experiences. Remember to keep your post anonymous by avoiding identifying details."
    },
    {
      number: "02",
      iconName: "Users",
      title: "Connect with Others",
      description: "Browse posts from people experiencing similar challenges. Read their stories and know you\'re not alone."
    },
    {
      number: "03",
      iconName: "Heart",
      title: "Give & Receive Support",
      description: "React to posts with 'I relate to you', 'You are correct', or 'Not the best choice'. See how many people support you."
    }
  ];

  return (
    <section id="how-it-works" className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="container mx-auto max-w-6xl">
        {/* Section header */}
        <div className="text-center mb-10 md:mb-14 lg:mb-16 space-y-3 md:space-y-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            How OnlyCuts Works
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Three simple steps to find support and connect with others who understand your emotional journey.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-8 md:space-y-12 lg:space-y-16">
          {steps?.map((step, index) => (
            <div 
              key={index}
              className="flex flex-col lg:flex-row items-start lg:items-center gap-6 md:gap-8 lg:gap-12"
            >
              {/* Step number and icon */}
              <div className="flex items-center gap-4 md:gap-6 lg:flex-col lg:items-center lg:gap-4 flex-shrink-0">
                <div className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-primary/20">
                  {step?.number}
                </div>
                <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/10 rounded-2xl">
                  <Icon 
                    name={step?.iconName} 
                    size={40} 
                    color="var(--color-primary)" 
                    strokeWidth={2}
                  />
                </div>
              </div>

              {/* Step content */}
              <div className="flex-1 space-y-3 md:space-y-4">
                <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
                  {step?.title}
                </h3>
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
                  {step?.description}
                </p>
              </div>

              {/* Connector line (hidden on last item) */}
              {index < steps?.length - 1 && (
                <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-0.5 h-16 bg-border"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;